module.exports = __webpack_public_path__ + "img/inactive_detractor.fb818c98.png";